import Vue from "vue";
import ValueChecker from "./../ValueChecker.js";

export default class EventManager {
    eventBus: Vue;
    httpClient: Object;

    constructor(eventBus: Vue, httpClient: Object) {
        this.eventBus = eventBus;
        this.httpClient = httpClient;
    }

    /**
     * @param eventsConfig
     * @param stack
     */
    emitEvents(eventsConfig: Array<any>, stack: Array<any>) {
        eventsConfig.every((event, index) => {
            let eventData = this.resolveData(event.config.data || {}, stack);

            switch (event.type) {
                case 'backend':
                    let url = event.config.url;
                    let paramsClient = {};

                    if (['GET', 'DELETE'].includes(event.config.method.toUpperCase())) {
                        eventData = Object.assign(paramsClient, {params: eventData});
                    } else {
                        Object.assign(paramsClient, {params: eventData});
                    }

                    if (undefined !== event.config.formData) {
                        Object.assign(paramsClient, {'Content-Type': 'multipart/form-data'});
                        let data = this.resolveData(event.config.formData || {}, stack);
                        eventData = this.convertToFormData(stack[0]['formData'], data);

                    }
                    if (this.isBinaryRequest(event.config)) {
                        paramsClient['responseType'] = 'arraybuffer';
                    }

                    this.httpClient[event.config.method](url, eventData, paramsClient).then(response => {
                        this.emitEventsResponse(response, stack, eventsConfig, index, event);
                    });

                    return false;
                case 'frontend':
                    let eventName = event.config.eventName;
                    let isEventCallback = this.checkIsCallbackEvent(eventName);

                    if (isEventCallback) {
                        let eventsConfigForPromise = this.prepareEventsConfigForPromiseInvoke(eventsConfig, index);
                        event.config.callback = this.emitEvents.bind(this, eventsConfigForPromise, stack);
                    }

                    this.eventBus.$emit(eventName, Object.assign(event.config, stack[0]), eventData);

                    if (isEventCallback) {
                        return false;
                    }

                    break;
            }

            return true;
        });
    }

    emitEventsResponse(response, stack, eventsConfig, index, event) {
        let eventsConfigForPromise = this.prepareEventsConfigForPromiseInvoke(eventsConfig, index);
        let responseData = response.data;

        if (this.isBinaryRequest(event.config)) {
            responseData = response;
        }

        stack.push(responseData);

        this.emitEvents(eventsConfigForPromise, stack);
    }

    /**
     * @param eventsConfig
     * @param component
     */
    bindEvents(eventsConfig: Array<any>, component) {
        eventsConfig.forEach(eventConfig => {
            let eventName = `${eventConfig.componentIndex}:${eventConfig.name}`;
            let eventMethodName = `${eventConfig.name}`;

            if (!ValueChecker.isFunction(component[eventMethodName])) {
                throw `Method not exists "${eventMethodName}"`;
            }

            this.eventBus.$on(eventName, component[eventConfig.name]);
        });
    }

    isBinaryRequest(config) {
        return undefined !== config.isBinaryData && config.isBinaryData;
    }

    /**
     * @param eventsConfig
     */
    unbindEvents(eventsConfig: Array<any>) {
        eventsConfig.forEach(eventConfig => {
            let eventName = `${eventConfig.componentIndex}:${eventConfig.name}`;
            this.eventBus.$off(eventName);
        });
    }

    /**
     * @param eventsConfig
     * @param currentIndex
     * @private
     */
    private prepareEventsConfigForPromiseInvoke(eventsConfig: Array<Object>, currentIndex: number): Array<Object> {
        return eventsConfig.slice(currentIndex + 1);
    }

    /**
     * @param eventName
     * @private
     */
    private checkIsCallbackEvent(eventName: string): boolean {
        return ['show-confirm-modal', 'show-modal-comp'].includes(eventName);
    }

    /**
     * @param data
     * @param stack
     * @private
     */
    private resolveData(data: Object, stack: Array<any>): Object {
        let res = {};

        if (Array.isArray(data) && data.length === 0) {
            return stack;
        }

        Object.entries(data).forEach(entry => {
            let [key, value] = entry;

            if (0 === key.length) {
                let valueStack = value.split('.');
                res = Object.assign(res, this.getValueFromStack(stack, valueStack));

                return;
            }

            if (ValueChecker.isObject(value)) {
                res = Object.assign(res, this.resolveData(value, stack));

                return;
            }

            if (ValueChecker.isString(value)) {
                let valueStack = value.split('.');
                res[key] = this.getValueFromStack(stack, valueStack);

                return;
            }

            res[key] = value;
        });

        return res;
    }

    /**
     * @param stack
     * @param valueStack
     * @private
     */
    private getValueFromStack(stack: Array<any>, valueStack: Array<string>) {
        let tmpStack = stack;

        valueStack.forEach(s => {
            tmpStack = tmpStack[s] || s;
        });

        return tmpStack;
    }

    /**
     * @param formData
     * @param eventData
     * @private
     */
    private convertToFormData(formData: FormData, eventData: Object): FormData
    {
        Object.entries(eventData).forEach(entry => {
            let [key, value] = entry;

            formData.append(key, value);
        });

        return formData;
    }
}



// WEBPACK FOOTER //
// ./src/services/eventManager/EventManager.ts